import React from "react";
import { Box, CircularProgress } from "@mui/joy";

interface ProcessingOverlayProps {
  isProcessing: boolean;
}

export const ProcessingOverlay: React.FC<ProcessingOverlayProps> = ({
  isProcessing,
}) => {
  if (!isProcessing) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "background.body",
          p: 3,
          borderRadius: "lg",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CircularProgress size="lg" />
        <Box sx={{ mt: 2, textAlign: "center" }}>Processing video...</Box>
      </Box>
    </Box>
  );
};
